export default "https://assets-v2.scaler.com/packs/images/green-check.316d10.svg";